// import axios from "axios";

// const API = "http://localhost/backend/public/index.php?route=cedula";

// export const consultarCedula = async (cedula, recaptchaToken) => {
//   const { data } = await axios.post(API, {
//     cedula,
//     recaptchaToken
//   });

//   return data;
// };

//const API_LOCAL = "http://localhost/CQSR_dev/CQSR/public/api/cedula.php";
const API_LOCAL = "/api/cedula.php";

/**
 * Consulta una cédula profesional mediante nuestro
 * proxy PHP local.
 *
 * @param {string|number} numeroCedula
 * @param {string} recaptchaToken
 */
export const consultarCedula = async (
  numeroCedula,
  recaptchaToken
) => {
  try {
    const response = await fetch(API_LOCAL, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        numCedula: String(numeroCedula).trim(),
        recaptchaToken,
      }),
    });

    // Intentamos obtener siempre el JSON
    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message ||
        `Error HTTP ${response.status}`
      );
    }

    return data;

  } catch (error) {
    console.error("consultarCedula:", error);
    throw error;
  }
};

